import { server_connection } from 'config';

export const GET_LAYOUT = '[DASHBOARD APP] GET LAYOUT';
export const SET_DASHBOARD_LAYOUT = '[DASHBOARD APP] SET DASHBOARD LAYOUT';

export function getLayout(auth_id, is_folded=false) {
    return (dispatch) => {
        fetch(server_connection + '/dashboard/layout/get/' + auth_id)
        .then((response) => response.json())
        .then((responseData) => {
            dispatch({
                type: GET_LAYOUT,
                payload: {
                    dashboard_layout: responseData, 
                    is_folded:        is_folded,
                }
            });
        });
    }
}

export function saveLayout(auth_id, grid_layout) {    
    return (dispatch) => {
        fetch(server_connection + '/dashboard/layout/save',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ auth_id, grid_layout })
            })
            .then((response) => {

                dispatch({
                    type: SET_DASHBOARD_LAYOUT,
                    payload: grid_layout
                });
            });
    }
}


// WEBPACK FOOTER //
// src/main/content/dashboard/store/actions/dashboard.actions.js